export default {
  nav: {
    nosotros: "About Us",
    talentos: "Talent",
    trabajo: "Our Work",
    cta: "Let's work together",
  },
  hero: {
    line1: "Creators",
    line2: "who move",
    line3: "audiences.",
    ctaPrimary: "Let's work together",
    ctaSecondary: "See the talent",
    scroll: "Scroll",
  },
  nosotros: {
    tag: "Who we are",
    title1: "The agency that",
    title2: "gets",
    title3: "creators.",
    body: "At 301+, we don't just represent talent — we build careers. We believe in the power of a well-told story and in the real connection between creators and the brands that shape culture. Our stage isn't the internet; it's lasting impact.",
    brandsLabel: "Brands that trust our talent",
    stats: [
      { value: "150+", label: "Campaigns delivered", desc: "From launches to full 360° campaigns" },
      { value: "20M+", label: "Reach generated", desc: "For our partner brands" },
      { value: "89%", label: "Client satisfaction", desc: "Brands that come back to us" },
    ],
  },
  talentos: {
    tag: "Exclusive roster",
    title1: "Our",
    title2: "Talent",
    followers: "Total followers",
    engagement: "Engagement",
    socials: "Social media",
  },
  enfoques: {
    label: "Our work",
    categories: [
      {
        tag: "Campaigns",
        subtitle: "From idea to impact",
        title: "Campaigns that spark conversation",
        desc: "We design campaigns from start to finish with the right talent for each brand.",
        highlights: ["Creative strategy", "Talent casting", "Production", "Impact reporting"],
        stat1Label: "Average ROI",
        stat2Label: "Successful campaigns",
      },
      {
        tag: "Events",
        subtitle: "Experiences that go beyond",
        title: "Events that become content",
        desc: "We turn every event into content that amplifies your brand beyond the day.",
        highlights: ["Live activations", "Product launches", "Press trips", "Brand experiences"],
        stat1Label: "Average attendees",
        stat2Label: "Events per year",
      },
      {
        tag: "Interviews",
        subtitle: "Voices people trust",
        title: "Interviews that build authority",
        desc: "Authentic voices that position your brand as a reference in its industry.",
        highlights: ["Podcasts", "Video interviews", "Brand conversations", "Thought leadership"],
        stat1Label: "Average reach",
        stat2Label: "Hours of content",
      },
      {
        tag: "Ambassadors",
        subtitle: "Relationships that build brands",
        title: "Long-term brand ambassadors",
        desc: "Lasting relationships that give your brand credibility and consistency.",
        highlights: ["Ambassador programs", "Annual contracts", "Personal brand development", "Exclusivity"],
        stat1Label: "Average retention",
        stat2Label: "Active partnerships",
      },
    ],
  },
  contacto: {
    tag: "Let's talk",
    title1: "let's work",
    title2: "together",
    copy: "Copy email",
    copied: "Copied",
  },
  footer: {
    brand: "301+ Management Agency",
    rights: "All rights reserved.",
  },
};